import { render, staticRenderFns } from "./HostNumberInfo.vue?vue&type=template&id=3edc21b6&scoped=true&"
import script from "./HostNumberInfo.vue?vue&type=script&lang=ts&"
export * from "./HostNumberInfo.vue?vue&type=script&lang=ts&"
import style0 from "./HostNumberInfo.vue?vue&type=style&index=0&id=3edc21b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc21b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
